__webpack_require__.p = "/app.studio.director/";